import React, { useEffect, useRef, useState } from "react";
import * as s from "./index.module.scss";
import { Col, Row } from "react-bootstrap";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";

const HowItWorks = ({ data }) => {
  const [hovered, setHovered] = useState(1);
  const reference = useRef(null);
  useEffect(() => {
    reference?.current?.addEventListener("mouseleave", () => {
      setHovered(1);
    });
    return () => {
      reference?.current?.removeEventListener("mouseleave", () => {
        setHovered(1);
      });
    };
  }, []);

  return (
    <section className={`${s.how_it_works}`}>
      {/* <div className={s.marker}></div> */}
      <Row className={`${s.how_it_works_wrapper}`}>
        <Col xs={12} md={8} lg={7} xxl={5} className={s.points_container}>
          <div className={`${s.heading}`}>
            <h2 className="title">
              {data?.how_it_works_title || "How It Works"}
            </h2>
            {data?.how_it_works_description ? (
              <div className={`title ${secondaryFont}`}>
                <PrismicRichText field={data?.how_it_works_description || []} />
              </div>
            ) : (
              <p>
                We have collateral loans at low interests to fulfil your
                financial needs
              </p>
            )}
          </div>
          <div className={s.points} ref={reference}>
            {data?.steps?.map(({ title, text }, idx) => {
              return (
                <div
                  key={idx + 1}
                  className={`${s.single_point} ${
                    hovered === idx + 1 ? s.point_hovered : ""
                  }`}
                  onMouseOver={() => {
                    setHovered(idx + 1);
                  }}
                >
                  <span>{idx + 1}</span>
                  <div>
                    <h3 className="heading fw-normal">{title}</h3>
                    <div className={`${secondaryFont} paragraph`}>
                      <PrismicRichText field={text || []} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className={s.extra_description}>
            {data?.extra_description && (
              <PrismicRichText field={data?.extra_description || []} />
            )}
          </div>
        </Col>
        <Col xs={12} md={4} lg={5} className={s.table_container}>
          {data?.table?.map(({ label, icon }, idx) => {
            return (
              <div className={s.table_field} key={idx}>
                <PrismicNextImage loading="lazy" field={icon} fallbackAlt="" />
                <p className={`paragraph ${secondaryFont}`}>{label}</p>
              </div>
            );
          })}
        </Col>
      </Row>
    </section>
  );
};

export default HowItWorks;
